import styled from "styled-components";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  gql,
  useMutation,
} from "@apollo/client";
import { TextInputWTitle } from "../inputs/TextInputWTitle";
import { TextBtn } from "../inputs/TextBtn";
import userPic from "../../assets/User/userprofile.svg"

const StyleCss = styled.div`
  grid-column: 1 / 13;
  width: auto !important;
  .loading-ep {
    display: flex;
    justify-content: center;
    margin: 100px auto 0;
  }
  .container {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 40px 40px 40px 20px;
    .rightelement,
    .leftelement {
      width: 48%;
    }
    .leftelement {
      width: calc(48% - 4rem);
      padding: 0 0 0 2rem;
      box-sizing: border-box;
      img {
        width: 100%;
        display: block;
      }
    }
    .full-width {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(110px / 12)));
      grid-gap: 10px;
      margin: 2rem 0 0;
      padding: 2rem 0 0;
      border-top: 1px solid var(--n-grey-3);
    }
    .vertical-devider {
      width: 1px;
      border-left: 1px solid var(--n-grey-3);
    }
    .row {
      margin: 2rem 0;
      padding: 0 10px;
      :first-child{
        margin: 0 0 2rem;
      }
      .textarea {
        height: 5rem !important;
        width: 50% !important;
      }
      .new-input {
        padding: 0 calc(1rem - 1px);
      }
      .image-file {
        display: flex;
        width: calc(100% - 1rem);
        padding: 0.5rem;
        border-radius: var(--border-radius);
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        .texts {
          width: calc(60% - 1.5rem);
          margin: 0 0.5rem 0 1rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            margin: 6px 0;
            font-size: 11px;
            font-weight: 500;
          }
          .desc {
            font-size: 11px;
            font-weight: normal;
            text-align: justify;
            color: var(--n-grey-7);
          }
        }
        .image {
          width: 40%;
          padding-top: 40%;
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          img {
            width: 100%;
            position: absolute;
            inset: 0 0 0 0;
            display: block;
            background-color: var(--n-grey-3);
          }
        }
      }
    }
  }
`;



const ChangePass_Mutation = gql`
  mutation ChangePass(
    $oldPass: String!
    $newPass: String!
  ) {
    changePass(
      oldPass: $oldPass
      newPass: $newPass
    ) {
      User_ID
      Name
      Surname
      ShowName
      Email
      Mobile
      Password
      Type
      Token
      PodcasterTerms
      Verified {
        Mobile
        Email
      }
    }
  }
`;


function PasswordChangeForm(props) {
  const history = useHistory();

  const [oldpass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPass_re, setNewPass_re] = useState("");
  
  const [errors, setErrors] = useState({
    pass: '',
    newPass: '',
    newPass_re: '',
  })

  const [ChangePass, changePassState] = useMutation(
    ChangePass_Mutation,
    {
      onCompleted: proccessData,
    }
  );

  
  function proccessData(newData) {
    console.log(newData)
    if (newData.changePass.User_ID) {
      // logined send to other parts
      // let userData = { ...newData.chnagePass };
      history.push("/profile/change-password/success");
    } else {
      let newErrors = errors;
      if(newData.changePass.Token){
        newErrors.newPass = newData.changePass.Token;
      }
      if(newData.changePass.Password){
        newErrors.pass = newData.changePass.Password;
      }
      setErrors(newErrors);
    }
  }

  function sendData(e) {
    e.preventDefault();
    if (newPass !== newPass_re) {
      setErrors({
        ...errors,
        newPass_re: "رمز های عبور یکسان نیستند",
      });
      return "";
    }
    ChangePass({
      variables: {
        oldPass: oldpass,
        newPass: newPass,
      },
    });
  }

  onchange = (e) => {
    let value = e.target.value;
    switch (e.target.name) {
      case "Password":
        setOldPass(value);
        break;
      case "newPassword":
        setNewPass(value);
        break;
      case "newPassword_re":
        setNewPass_re(value);
        break;
      default:
        break;
    }
  };


  const checkData = () => {
    if (
      oldpass &&
      newPass &&
      newPass_re
    ) {
      return true;
    } else {
      return false;
    }
  };


  // let data2 = props.userdata
  return (
    <StyleCss>
      <div className="container">
        <div className="rightelement">
          <div className="row">
            <TextInputWTitle
              title="رمز عبور قبلی"
              name={"Password"}
              value={oldpass}
              error={errors.pass}
              placeHolder={""}
              type={"password"}
              onchange={onchange}
              center={true}
            />
          </div>
          <div className="row">
            <TextInputWTitle
              title="رمز عبور جدید"
              name={"newPassword"}
              value={newPass}
              error={errors.newPass}
              placeHolder={""}
              type={"password"}
              onchange={onchange}
              center={true}
            />
          </div>
          <div className="row">
            <TextInputWTitle
              title="تکرار رمز عبور جدید"
              name={"newPassword_re"}
              value={newPass_re}
              error={errors.newPass_re}
              placeHolder={""}
              type={"password"}
              onchange={onchange}
              center={true}
            />
          </div>
        </div>
        <div className="leftelement">
          <img src={userPic} alt="user"/>
        </div>
        <div className='full-width'>
          <div style={{ gridColumn: "9 / 13" }}>
            <TextBtn
                text={"ذخیره تغییرات"}
                type={"submit"}
                onclick={sendData}
                loading={changePassState.loading}
                disabled={!checkData() || changePassState.loading}
            />
          </div>
        </div>
      </div>
    </StyleCss>
  );
}
export default PasswordChangeForm;
